module.exports = __webpack_public_path__ + "img/pH.0882d0cc.png";